import { getOrderPassengerPoints } from "../../../../../../../redux/constants/OrdersPage/order";

import type { Order } from "../../../../../../../services";

const cellProcessing = (item?: Order.Model): string => {
	const points = getOrderPassengerPoints(item) ?? [];
	return points?.[0]?.settlement ?? "";
};

export default cellProcessing;
